export default __webpack_public_path__ + "static/O0026-47d3ff8892702d0084ff9597c683247a.png";